import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { Basket } from '@tsTypes/api/Basket';

const useBasket = ({ basketKey }: { basketKey: string }) => {
  const queryClient = useQueryClient();

  const query = useQuery<Partial<Basket | { [key: string]: never }>>({
    queryKey: [basketKey],
    queryFn: () => queryClient.getQueryData<Basket>([basketKey]) || {},
  });

  return {
    ...query,
    data: query?.data ?? {},
    isBasketCreated: !!query?.data?.id,
  };
};

export default useBasket;
